import React from "react";
import { IIcons } from "./icons";

const UnlockIcon = ({ fillColor }: IIcons.IconProps) => (
  <svg
    width="20"
    height="36"
    viewBox="0 0 72 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={fillColor}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3621 20.7957C14.3621 9.39314 23.9076 0.214844 35.7662 0.214844C47.6248 0.214844 57.1703 9.39314 57.1703 20.7957V22.7098L50.0356 26.5412V20.7957C50.0356 12.9841 43.8903 7.07512 35.7662 7.07512C27.6421 7.07512 21.4968 12.9841 21.4968 20.7957V34.5162H50.0356V34.4847H57.1703V34.5162C65.0156 34.5162 71.4397 40.6932 71.4397 48.2368V75.6779C71.4397 83.2215 65.0156 89.3984 57.1703 89.3984H14.3621C6.51678 89.3984 0.0927734 83.2215 0.0927734 75.6779V48.2368C0.0927734 40.6932 6.51678 34.5162 14.3621 34.5162V20.7957ZM42.9009 58.5272C42.9009 54.7487 39.6959 51.6669 35.7662 51.6669C31.8366 51.6669 28.6315 54.7487 28.6315 58.5272C28.6315 60.9256 30.0529 63.2838 32.1989 64.3156V72.2477C32.1989 74.3112 33.6202 75.6779 35.7662 75.6779C37.9122 75.6779 39.3336 74.3112 39.3336 72.2477V64.3156C41.4795 63.2838 42.9009 60.9256 42.9009 58.5272Z"
      fill="#9C9C9C"
    />
  </svg>
);
export default UnlockIcon;
